import { Outlet } from 'react-router-dom';
import { useEffect } from 'preact/hooks';
import { ClearPage } from '@util/analyticsHelper.js';

export function AnalyticsTracking() {
  useEffect(() => {
    return () => {
      ClearPage();
    };
  });

  return <Outlet />;
}
